import {TFunction} from "react-i18next";
import cn from "classnames";
import classes from "./column.module.css";
import {Cell, UseExpandedRowProps} from "react-table";
import {EducationMemberRow, Participation} from "../../../../schema";
import {UserEmotionEmoji} from "../../UserEmotionEmoji";
import WithTooltip from "../../../../ui/tooltip";
type CellDataType = EducationMemberRow | Participation;
type MembersCell = Cell<CellDataType> & {
  row: UseExpandedRowProps<CellDataType>;
};

function getEmotionColumn(t: TFunction<"translation", undefined>) {
  return {
    id: "top3Emotions",
    Header: () => t("components.MembersTable.top3Emotions"),
    Cell: ({row}: MembersCell) => {
      switch (row.original.__typename) {
        case "EducationMemberRow":
          return row.original.user.top3Emotions ? (
            <div className={cn(classes.centerAlign, classes.displayFlex)}>
              {row.original.user.top3Emotions.map((emotion, index, {length}) => {
                const size = (length - 1 - index) * 3 + 15;
                const value = (emotion.value * 100).toFixed(1);
                return (
                  <WithTooltip
                    placement="top"
                    key={index}
                    helpText={`${t(`types.UserEmotion.${emotion.key}`)} (${value}%)`}
                  >
                    <span
                      key={`${row.original.id}${emotion.key}`}
                      className={classes.noTextCursor}
                      style={{fontSize: `${size}px`}}
                    >
                      {UserEmotionEmoji[emotion.key]}
                    </span>
                  </WithTooltip>
                );
              })}
            </div>
          ) : (
            <></>
          );
        case "Participation":
          return "";
        default:
          return "NotImplemented";
      }
    },
  };
}

export default getEmotionColumn;
